import styled from 'styled-components';
import Markdown from 'react-markdown';
import { media } from '../../utils/media';

export const CardIcon = styled.img`
    width: 40px;
    height: 40x;
    color: ${({ theme }) => theme.color};
    margin: 0 0 20px;
   
    ${media.desktop`
      width: 80px;
      height: 80px;
    `}
`;

export const CardHeader = styled.div``

export const ImageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const CardTitle = styled.div`
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color};
  margin: 0 0 15px;
`

export const CardContent = styled(Markdown)`
  h3 {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    margin: 0 45px;
    color: ${({ theme }) => theme.color};
  }
  p { 
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 27px;
  }
  li { 
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 27px;
  }
  a {
    color: ${({ theme }) => theme.color};
  }
  overflow: ${props => props.className === 'hidden' ? '' : 'hidden'};
  text-overflow: ${props => props.className === 'hidden' ? '' : 'ellipsis'};
  display: ${props => props.className === 'hidden' ? '' : '-webkit-box'};
  -webkit-line-clamp: ${props => props.className === 'hidden' ? '' : '3'};
  -webkit-box-orient: ${props => props.className === 'hidden' ? '' : 'vertical'};
`;

export const Card = styled.div`
  padding: 10px 20px;
  min-height: 207px;
  height: ${props => props.className === 'hidden' ? 'auto' : '100%'};
  :last-child {
    margin-right: 0;
  }
  width: 300px;
  background: ${({ theme }) => theme.background};
`;

export const ExpandButton = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.color};
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  padding: 15px 0 0 0;
  &:hover {
    cursor: pointer;
  }
`